import { useCallback } from 'react';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { TownsquareProjectAri } from '@atlassian/ari/townsquare/project';
import { ATLASSIAN_HOME_URL, ATLASSIAN_HOME_URL_STAGING } from './constants.tsx';

export const useProjectUrlConstructor = () => {
	const { data: orgId } = useOrgId();
	const isStagingOrDevOrLocal = useIsStagingOrDevOrLocal();

	return useCallback(
		({ ari, projectKey }: { ari: string; projectKey: string }) => {
			const atlassianHomeUrl = isStagingOrDevOrLocal
				? ATLASSIAN_HOME_URL_STAGING
				: ATLASSIAN_HOME_URL;

			const siteId = TownsquareProjectAri.parse(ari).siteId;
			return `${atlassianHomeUrl}/o/${orgId}/s/${siteId}/project/${projectKey}`;
		},
		[isStagingOrDevOrLocal, orgId],
	);
};

export const getProjectKeyFromUrl = (url: string) => url.split('/').pop();
